var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPipedrive = function SvgPipedrive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 455,
    height: 455,
    viewBox: "0 0 455 455",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455 227.5C455 353.145 353.145 455 227.5 455C101.855 455 0 353.145 0 227.5C0 101.855 101.855 0 227.5 0C353.145 0 455 101.855 455 227.5Z",
    fill: "#26292C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.458 67C216.674 67 195.925 83.25 186.002 94.084C184.799 84.454 178.484 72.116 153.826 72.116H100V128.09H121.952C125.56 128.09 126.763 129.293 126.763 132.905V389H190.512V286.08C200.436 295.108 219.38 307.748 249.15 307.748C311.396 307.748 354.998 258.394 354.998 187.374C355.299 115.45 313.802 67 252.458 67ZM239.527 252.075C205.247 252.075 189.61 219.273 189.61 188.578C189.61 140.428 215.772 123.275 240.43 123.275C270.5 123.275 290.948 149.155 290.948 187.976C290.647 232.514 264.787 252.075 239.527 252.075Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPipedrive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pipedrive.26e05d0e.svg";
export { ForwardRef as ReactComponent };